module.exports = __webpack_public_path__ + "img/produksi-grafika.060b2ce7.png";